import { useRouteError } from 'react-router';

import { MainErrorFallback } from './main';

const RouterErrorFallback = () => {
  const error = useRouteError();
  return <MainErrorFallback error={error as Error} />;
};

RouterErrorFallback.displayName = 'RouterErrorFallback';

export { RouterErrorFallback };
